module.exports = __webpack_public_path__ + "media/images/project/reward/r1000-7b44e5d8f8b6e6cf6331a94f3d75078d.jpg";